// created by Katarzyna Krasnowska for SCWAD demo
// based on allenai/varnish/components/Footer

import * as React from 'react';
import styled from 'styled-components';
import DICT from "../Dictionary";

/*
    NOTE: This must import `ExternalLink` individually, instead of using the
    barrel file (i.e. `import { ExternalLink } from './link'`), as otherwise
    `react-router-dom` is required by all users of the `Footer`. This ensures
    sites that use an alternative router (i.e. those powered by say, NextJS)
    to be able to use the `Footer`.
*/
import { ExternalLink } from '@allenai/varnish/components/link/ExternalLink';
import { Body } from '@allenai/varnish/components/typography';
import { LayoutFooter } from '@allenai/varnish/components/Layout';
import { LayoutContext } from '@allenai/varnish/layout';

export type FooterVariant = 'default' | 'dark';

//interface Props {
//    variant?: FooterVariant;
//    children?: React.ReactNode | React.ReactNodeArray;
//    /* If true, the background of the parent "page" (the body and html elements)
//       is adjusted to match that of the footer. */
//    setPageBackground?: boolean;
//    layout?: LayoutVariant;
//    className?: string;
//}

export class Footer extends React.PureComponent<Props> {
    static defaultProps = {
        setPageBackground: true
    };

    render() {
        // Footer is always english.
        let language = "english";
        // if (window.location.pathname.includes("combo-eng")) {
        //     language = "english"
        // }
        return (
            <LayoutContext.Consumer>
                {() => (
                    <StyledFooter
                        className={this.props.className}>
                        {this.props.children ? (
                            this.props.children
                        ) : (
                            <Body>
                                Copyright ©{' '}
                                <ExternalLink href={DICT["ipi_url"][language]} target="_blank" rel="noopener">
                                    {DICT["ipi"][language]}
                                </ExternalLink>{' | '}
                                {DICT["app_based_on"][language]} {' '}
                                <ExternalLink href="https://demo.allennlp.org" target="_blank" rel="noopener">
                                    AllenNLP demo.
                                </ExternalLink><br/>
                                {DICT["work_financed_by"][language]}
                            </Body>
                        )}
                    </StyledFooter>
                )}
            </LayoutContext.Consumer>
        );
    }
}

const StyledFooter = styled(LayoutFooter)`
    && {
        background: ${({ theme }) =>
            theme.palette.background.light};
        color: ${({ theme }) =>
            theme.palette.text.default}};
    }
`;
